import Layout from "../../layout";
import React, {useState, useEffect} from "react";
import {Container, Button, FormSelect} from "react-bootstrap";
import Form from "./form";
import DataTable from "./datatable";
import axios from 'axios';

function Index() {
    const [page, setPage] = useState(1);
    const [contents, setContents] = useState([]);
    const [change, setChange] = useState(0);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState(-1);

    useEffect(() => {
        document.title = 'İçerik Yönetimi';
        axios.post(`${process.env.REACT_APP_API_URL}/content`, {page: page ?? 1, filter: filter ?? -1})
            .then(function (response) {
                console.log(response);
                if (response.data.status === true) {
                    if (page > response.data.pageCount) setPage(response.data.pageCount);
                    setContents(response.data);
                    setLoading(false);
                } else {
                    console.log(response);
                }
            });
    }, [change,filter]);

    function handleChange(event) {
        setFilter(event.target.value);
    }

    const deleteItem = async (contentId) => {
        await axios.post(`${process.env.REACT_APP_API_URL}/content/delete/${contentId}`)
            .then(function (response) {
                if (response.data.status === true) {
                    setChange((change) => change + 1);
                } else {
                    console.log(response.data);
                }
            });
    }

    return (
        <Layout>
            {loading ?
                <img className="loading" src={require("../../../src/images/loading.gif")}/>
                :
                <>
                    <div className="bg-white mb-3 border-bottom py-2">
                        <Container className="d-flex justify-content-between align-items-center">
                            <h2 className="mb-0 fs-5">{document.title}</h2>

                            {localStorage.getItem('userRole') > 0 &&

                                <div className={"d-flex justify-content-between"}>
                                    <FormSelect onChange={handleChange} style={{width: 200, marginRight: 15}} name={"contentType"}>
                                        <option value={-1}>Tümü</option>
                                        <option value={0}>Müsait</option>
                                        <option value={1}>Dolu</option>
                                        <option value={2}>Onay aşamasında</option>
                                        <option value={3}>Yayınlandı</option>
                                    </FormSelect>

                                    <Button className="py-1 px-3" onClick={(show) => setShow(true)}>Başlık Ekle</Button>
                                </div>
                            }
                        </Container>
                    </div>
                    <Container>
                        <DataTable response={contents} setPage={setPage} deleteItem={deleteItem} change={change}
                                   setChange={setChange} loading={loading}/>
                    </Container>

                    {show && <Form change={change} setChange={setChange} show={show} setShow={setShow}/>}</>

            }
        </Layout>
    );
}

export default Index;


